export default __webpack_public_path__ + "static/media/portfolio-image.b3239e7d.jpg";